import CreateProposal from "./CreateProposal/CreateProposal";
import ProposalList from "./CreateProposal/ProposalList";
import ProposalInwardList from "./ProposalInwardList";
import ProposalApproval from "./ProposalApproval";
import CreateProposalStatewise from "./CreateProposal/CreateProposalStatewise";
import ProposalInwardStateWise from "./ProposalInwardStateWise";
import EditProposal from "./EditProposal/EditProposal";

export { CreateProposal, ProposalList, ProposalInwardList, ProposalApproval, CreateProposalStatewise, ProposalInwardStateWise  , EditProposal};